/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EFeatureId {
  CustomBalloons = 1,
  DrivingStyle = 7,
  Privacy = 43,
  DriverApp = 53,
  Towing = 54,
  MisLive = 69,
  RealTimeTachoDate = 78,
  Ecm = 83,
  DeviceStatusChange = 90,
  AssetTracking = 93,
  VideoExperience = 100,
  RoadSideAssistance = 104,
  MandatoryGeofenceGroups = 106,
  VideoAccess = 112,
  ManagePostedSpeed = 134
}
